import React from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  background?: 'cream' | 'cream-dark' | 'white' | 'sage';
}
export function Section({
  children,
  className = '',
  id,
  background = 'cream'
}: SectionProps) {
  const backgrounds = {
    cream: 'bg-brand-cream',
    'cream-dark': 'bg-brand-cream-dark',
    white: 'bg-white',
    sage: 'bg-brand-sage/10'
  };
  return <section id={id} className={`py-16 md:py-24 px-4 sm:px-6 lg:px-8 ${backgrounds[background]} ${className}`} data-id="element-320">
      <div className="max-w-7xl mx-auto w-full" data-id="element-321">{children}</div>
    </section>;
}